import { InputHTMLAttributes, forwardRef, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { InputGroupContext } from './InputGroupContext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      border: 'none',
      outline: 'none',
      backgroundColor: 'transparent',
      color: 'inherit',
      padding: 0,
      flex: 1,
      resize: 'none',

      fontFamily: theme.typography.body1.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
    },
  });

export interface InputGroupInputProps
  extends InputHTMLAttributes<HTMLInputElement>,
    WithStyles<typeof styles> {
  value?: string;
}

const InputGroupInput = forwardRef<HTMLInputElement, InputGroupInputProps>(
  (
    { className, classes, disabled: disabledProp, type = 'text', ...rest },
    ref,
  ) => {
    const { disabled } = useContext(InputGroupContext);

    return (
      <input
        ref={ref}
        className={classNames(classes.root, className)}
        data-slot="input"
        disabled={disabled || disabledProp}
        type={type}
        {...rest}
      />
    );
  },
);

InputGroupInput.displayName = 'InputGroup.Input';

export default withStyles(styles)(InputGroupInput);
